import React from 'react';
import classNames from 'classnames';
import { Render, Image, withLazyLoad, withSrcSets } from '../../platformui';

const LazyLoadImage = withSrcSets(withLazyLoad(Image));

const Entry = (props) => {
  const entryClass = classNames({
    'c-intro-content__item': true,
    'c-entry': true,
  });

  return (
    <a href={props.Href} target={props.Target} className={entryClass}>
      <div className="c-intro-content__item__container">
        <div className="c-entry__content-container">
          {(props.index + 1) % 3 !== 0 && (
            <div className="c-entry__img-container">
              <Render.Block
                blocks={props.Media}
                propertyName="ImageReference"
                currentPageProps={props.CurrentPageProps}
              >
                <LazyLoadImage
                  className="c-entry__img"
                  isBackgroundImage={true}
                  DefaultPreset={{ name: 'preset_800' }}
                  Sizes={{
                    sizes:
                      '(min-width: 1025px) 407px, (min-width: 640px) calc(100vw / 3), 100vw',
                  }}
                />
              </Render.Block>
            </div>
          )}
          <div className="c-entry__content">
            <div className="c-entry__content__inner">
              <h3 className="c-entry__heading">{props.Heading}</h3>
              <p className="c-entry__text">{props.Description}</p>
            </div>
          </div>
        </div>
      </div>
    </a>
  );
};

export default Entry;
